<template>
  <div>
    <v-dialog
      v-model="dialogForm"
      scrollable
      persistent
      content-class="br-15"
      width="900"
      :z-index="200"
    >
      <v-card>
          <v-toolbar
              elevation="0"
              dark
              class="primary-degrade white--text fix-flex"
          >
              <v-toolbar-title>
                  Importar Gabarito
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  fab
                  width="24px"
                  height="24px"
                  elevation="0"
                  light
                  @click="dialogForm = false"
              >
                  <v-icon size="18px" color="primary">mdi-close</v-icon>
              </v-btn>
          </v-toolbar>
          <v-card-text class="mt-5 pb-0">
              <div class="instrucoes">
                  <h4 color="primary">
                      Para importar uma base de gabarito, siga as
                      instruções abaixo
                  </h4>
                  <ul>
                      <li>
                          A base utilizada para importação deve ser
                          parecido ao modelo extraída abaixo (Modelo de
                          Importação).
                      </li>
                      <li>
                          As colunas 
                          <strong>ID Ativação</strong> (Código da ativação), 
                          <strong>Device</strong> ,
                          <strong>ID Categoria</strong>,
                            são
                          <strong>obrigatórias</strong> , as demais
                          colunas podem ser excluidas.
                      </li>
                      <li>
                          Para informar um
                          <strong>device</strong> (Dispositivo) para a
                          ativação, deve ser inserido um caractere
                          <strong>X</strong> na coluna referente ao
                          dispositivo, qualquer outro valor será
                          considerado como <strong>desativado</strong>.
                      </li>

                      <li>
                          As linhas sem valores para
                          <strong>id_ativacao</strong> (Código da
                          ativação) é serão consideradas para
                          <strong>inserção</strong>. Caso a linha possua
                          um valor para <strong>id_ativacao</strong> será
                          considerada para <strong>edição</strong>.
                      </li>
                      <li>
                          O campo <strong>custo</strong> não é
                          obrigatorio, e deve ser preenchido no seguinte
                          formato: R$ 1,00
                      </li>
                      <li>
                          Recomendamos excluir as linhas que não sofrerão
                          alteração, para evitar erros.
                      </li>
                  </ul>
              </div>
     <v-row>
            <v-col>
              <v-alert
                v-if="erroImportacao"
                type="error"
                text
                icon="mdi-close-circle"
                class="justify-center"
              >
                <v-row align="center">
                  <v-col class="grow py-0">{{ errosMensagem }}</v-col>
                  <v-col class="shrink py-0">
                    <v-btn
                      v-if="errosImportacao && errosImportacao.length > 0"
                      color="red"
                      @click="dialogErro = true"
                      small
                      style="font-size: 16px; font-weight: 500"
                    >
                      Exibir erros
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
              
              <v-alert
                v-if="sucessos.length > 0"
                type="success"
                text
                icon="mdi-check-circle"
                class="justify-center"
              >
                <v-row align="center">
                  <v-col class="grow py-0">
                    As demais linhas foram processadas com sucesso. Total de
                    linhas processadas: {{ sucessos.length }}
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
          
          <v-form ref="formImportacao">
            <v-row class="mt-5">
              <v-col cols="12" class="pb-0">
                <v-file-input
                  label="Arquivo CSV"
                  class="input-cinza"
                  outlined
                  dense
                  v-model="arquivoCSV"
                  accept=".csv"
                  :rules="regra.csv"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        
        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="new-button px-6 mb-3 mr-2"
            @click="importar()"
          >
            <v-icon left>mdi-upload</v-icon>
            Importar Arquivo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      content-class="br-15"
      v-model="dialogErro"
      width="800"
      :z-index="400"
    >
      <v-card>
        <v-toolbar elevation="0" dark class="error white--text fix-flex">
          <v-toolbar-title>Erros durante a importação</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            fab
            width="24px"
            height="24px"
            elevation="0"
            light
            @click="dialogErro = false"
          >
            <v-icon size="18px" color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text class="mt-4">
          <v-data-table
            :headers="headerErros"
            class="elevation-0 tabela"
            :items="errosImportacao"
            :items-per-page="10"
            :footer-props="tableConfig"
            color="error"
          ></v-data-table>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <download-csv
            :data="errosImportacao"
            :labels="errosLabels"
            name="erros_plano_pacote.csv"
            delimiter=";"
          >
            <v-btn class="new-button px-4 mb-2" color="primary">
              <v-icon class="mr-3">mdi-microsoft-excel</v-icon>
              Exportar erros em CSV
            </v-btn>
          </download-csv>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-overlay :value="carregando" :z-index="300">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'ImportacaoPlanoPacote',
  props: ["value"],
  
  data() {
    return {
      dialogForm: false,
      dialogErro: false,
      carregando: false,
      arquivoCSV: null,
      sucessos: [],
      erroImportacao: false,
      errosImportacao: [],
      headerErros: [
        { text: "Descrição", value: "mensagem", class: "th-separador" },
        { text: "Linha", value: "linha", align: "center", width: "100px" },
      ],
      errosLabels: {
        msg: "Descrição",
        linha: "Linha",
      },
      tableConfig: {
        itemsPerPageOptions: [10, 15, 25, 50, 100],
        itemsPerPageText: "Linhas por páginas",
        ofText: "de",
        pageText: "{0}-{1} de {2}",
      },
      errosMensagem: "",
      regra: {
        csv: [
          (v) => !!v || "Selecione um arquivo.",
          (v) =>
            (!!v && [".csv", ".CSV"].includes(v.name.substr(-4))) ||
            "O arquivo deve ser do tipo CSV.",
        ],
      },
    };
  },
  
  watch: {
    value(val) {
      this.dialogForm = val;
    },
    dialogForm(val) {
      this.$emit('input', val);
      if (!val) {
        this.resetarFormulario();
      }
    }
  },
  
  methods: {
    async exportar(){
      this.$emit("exportar");
    },
    async importar() {
      if (!this.$refs.formImportacao.validate()) return;
      
      this.erroImportacao = false;
      this.errosImportacao = [];
      this.errosMensagem = "";
      this.sucessos = [];
      
      this.carregando = true;
      
      const formData = new FormData();
      formData.append("files", this.arquivoCSV);
      
      try {
        const response = await this.$http().post(
          "/planejamentoEcommerce/gabarito/importar",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        
        if (response.status != 200 || response.data.erros){
          this.erroImportacao = true;
          this.errosImportacao = response.data?.erros || [];
          this.sucessos = response.data?.sucessos || [];
          this.errosMensagem =
          response.data.mensagem || "Erro ao importar gabarito";
          this.carregando = false;
          return;
        }
        
        if (response.status == 200 && !response.data.error) {
          this.$emit("filtrar");
          this.dialogForm = false;
          this.$dialog.notify.success("Gabarito importado com sucesso!", {
            position: "top-right",
            timeout: 5000,
          });
        } 
      } catch (error) {
        this.erroImportacao = true;
        this.errosMensagem = "Erro de conexão ao importar Plano/Pacote";
        console.error("Erro na importação:", error);
      }
      
      this.carregando = false;
    },
    
    abrirImportacao() {
      this.dialogForm = true;
      this.resetarFormulario();
    },
    
    resetarFormulario() {
      this.arquivoCSV = null;
      this.erroImportacao = false;
      this.errosImportacao = [];
      this.sucessos = [];
      this.errosMensagem = "";
      
      if (this.$refs.formImportacao) {
        this.$refs.formImportacao.resetValidation();
      }
    },
  },
};
</script>
